import React, { useState } from "react";
import ChooseDeviceField from "./ChooseDeviceField";
import DeviceTypeField from "./DeviceTypeField";

function RecentViolationsTableManagement() {


    const [selectedDeviceTypeId, setSelectedDeviceTypeId] = useState();

    return (
        <div className="container oct_display-none">
            <form action="" className="oct_form pt-5">
                <div className="row mb-3">
                    <div className="col-xs-12 col-sm-6 col-md-5 col-xl-6">
                        <DeviceTypeField selectedType={selectedDeviceTypeId} selectType={setSelectedDeviceTypeId} />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-5 col-xl-6">
                        <ChooseDeviceField selectedType={selectedDeviceTypeId} />
                    </div>
                </div>
            </form>
        </div>
    )

}


export default RecentViolationsTableManagement;